/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum CommunicationLanguage {
    EN = 'EN',
    ES = 'ES'
}

export function CommunicationLanguageFromJSON(json: any): CommunicationLanguage {
    return CommunicationLanguageFromJSONTyped(json, false);
}

export function CommunicationLanguageFromJSONTyped(json: any, ignoreDiscriminator: boolean): CommunicationLanguage {
    return json as CommunicationLanguage;
}

export function CommunicationLanguageToJSON(value?: CommunicationLanguage | null): any {
    return value as any;
}

